var treeEditBind = { item: '=', index: '=', parent: '=' };
var TreeEditController = (function () {
    function TreeEditController(topic) {
        this.topic = topic;
        this.visible = true;
    }
    TreeEditController.prototype.getChildren = function () {
        switch (this.item.type) {
            case 'calculation': {
                return this.item.drpgs;
            }
            case 'drpg': {
                return this.item.partNumbers;
            }
            case 'partNumber': {
                return this.item.lineItems;
            }
        }
    };
    TreeEditController.prototype.getPlaceholder = function () {
        switch (this.item.type) {
            case 'drpg': {
                return 'Brand Family';
            }
            case 'partNumber': {
                return 'Part Number';
            }
            case 'lineItem': {
                return 'Revenue Line Item';
            }
        }
    };
    // idea is to copy everything, then clear copied values:
    // - ids
    // - amounts
    // - leave one line item per part number
    TreeEditController.prototype.copyItem = function () {
        this.topic.requireRecalculation = true;
        this.topic.changed = true;
        TreeEdit.addChild(this.item, this.parent);
    };
    TreeEditController.prototype.removeItem = function () {
        switch (this.item.type) {
            case 'drpg': {
                this.parent.item.drpgs.splice(this.index, 1);
                break;
            }
            case 'partNumber': {
                this.parent.item.partNumbers.splice(this.index, 1);
                if (!this.parent.item.partNumbers.length) {
                    this.parent.removeItem();
                }
                break;
            }
            case 'lineItem': {
                this.parent.item.lineItems.splice(this.index, 1);
                if (!this.parent.item.lineItems.length) {
                    this.parent.removeItem();
                }
                break;
            }
        }
    };
    TreeEditController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    TreeEditController.prototype.fieldChanged = function () {
        this.topic.requireRecalculation = true;
        this.topic.changed = true;
    };
    TreeEditController.prototype.getErrors = function () {
        return this.item.errors.errorList.join('\n');
    };
    TreeEditController.prototype.isError = function () {
        return this.item.errors.errorList.length;
    };
    TreeEditController.$inject = ['topic'];
    return TreeEditController;
}());
angular
    .module('application')
    .component('treeEditPayment', new TreeEditComponent());

//# sourceMappingURL=treeEditController.js.map
